<header>Weryfikacja adresu e-mail</header>

<ng-container *ngIf="verificationStatus$ | async as status; else loader">
  <div *ngIf="status === verificationStatus.REJECTED">
    <p class="completed">Kod weryfikacyjny jest nieprawidłowy lub stracił ważność.</p>
    <p>Zaloguj się, aby móc skorzystać z opcji ponownej wysyłki kodu.</p>
    <app-new-loader-button
      *ngIf="!authStore.isAuthenticated"
      [customType]="LoaderButtonType.RAISED"
      color="accent"
      class="auth-button"
      [routerLink]="'/auth/login'"
    >
      Zaloguj się
    </app-new-loader-button>
  </div>

  <div *ngIf="status === verificationStatus.VERIFIED">
    <div *ngIf="authStore.isAuthenticated">
      <p class="completed">
        Gratulacje! Adres e-mail: <b>{{ email }}</b> został potwierdzony. Możesz teraz przejść do serwisu.
      </p>

      <app-new-loader-button
        [customType]="LoaderButtonType.RAISED"
        color="accent" class="auth-button" (buttonClick)="goToApp()">
        Przejdź do serwisu
      </app-new-loader-button>
    </div>
    <div *ngIf="!authStore.isAuthenticated">
      <p class="completed">
        Gratulacje! Adres e-mail: <b>{{ email }}</b> został potwierdzony. Możesz teraz zalogować się do serwisu.
      </p>
      <app-new-loader-button
        [customType]="LoaderButtonType.RAISED"
        color="accent" class="auth-button" [routerLink]="'/auth/login'">
        Zaloguj się do aplikacji
      </app-new-loader-button>
    </div>
  </div>
</ng-container>
<ng-template #loader>
  <app-loading></app-loading>
</ng-template>
